import { Link } from 'react-router-dom';
import { BlogArticle } from '../../../mocks/blog';

interface ArticleCardProps {
  article: BlogArticle;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link to={`/blog/${article.slug}`} className="group relative bg-cream-50 border border-gold-100 rounded-2xl overflow-hidden hover:border-gold-300 transition-all duration-500 cursor-pointer h-full flex flex-col">
      {/* Golden glow on hover */}
      <div className="absolute inset-0 bg-gradient-to-br from-gold-500/0 via-gold-500/5 to-gold-500/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none z-10"></div>
      
      {/* Image */}
      <div className="relative h-56 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal-950/50 via-transparent to-transparent z-10"></div>
        <img
          src={article.coverImage}
          alt={article.title}
          className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
        />
        
        {/* Category badge */}
        <div className="absolute top-4 left-4 z-20">
          <span className={`inline-block px-3 py-1.5 bg-gradient-to-r ${article.categoryColor} text-white text-xs font-semibold rounded-full whitespace-nowrap`}>
            {article.category}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="p-6 flex flex-col flex-1">
        {/* Title */}
        <h3 className="text-xl font-bold text-charcoal-800 mb-3 group-hover:text-gold-600 transition-colors line-clamp-2 font-['Playfair_Display']">
          {article.title}
        </h3>

        {/* Excerpt */}
        <p className="text-charcoal-500 mb-4 leading-relaxed line-clamp-3 flex-1 text-sm">
          {article.excerpt}
        </p>

        {/* Meta info */}
        <div className="flex items-center justify-between pt-4 border-t border-gold-100">
          <div className="flex items-center gap-2">
            <img
              src={article.author.avatar}
              alt={article.author.name}
              className="w-8 h-8 rounded-full object-cover border-2 border-gold-300"
            />
            <div>
              <p className="text-sm font-semibold text-charcoal-700">{article.author.name}</p>
              <p className="text-xs text-charcoal-400">
                {new Date(article.publishedAt).toLocaleDateString('pt-BR', {
                  day: 'numeric',
                  month: 'short',
                  year: 'numeric',
                })}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-1.5 text-charcoal-400">
            <i className="ri-time-line text-sm"></i>
            <span className="text-xs whitespace-nowrap">{article.readTime}</span>
          </div>
        </div>
      </div>

      {/* Bottom golden line */}
      <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-gold-400 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
    </Link>
  );
}
